// 2. 제품 증상 입력

// 동적 코드 매핑 데이터
let dynamicPartList = {};
let dynamicPartOrder = [];
let dynamicSymptomsByParent = {};
let isPartCodeLoadSucceeded = false;
let isSymptomCodeLoadSucceeded = false;

const AS_CODE_INFO_ENDPOINT = 'https://sidiz-shopify.sidiz.com/v2/as/asCodeInfo';
const AS_CODE_PARENT = 'AA1';
const AS_CODE_CHILD = 'AA2';
const AS_PART_CODE_LOAD_ERROR_TEXT = '부위 정보를 불러오지 못했습니다.';
const AS_SYMPTOM_CODE_LOAD_ERROR_TEXT = '증상 정보를 불러오지 못했습니다.';
const AS_SYMPTOM_EMPTY_MAPPING_TEXT = '선택한 부위에 해당하는 증상 정보가 없습니다.';

const MAX_CHAR_LIMIT = 800;
const MIN_CHAR_LIMIT = 30;
const TEXT_COUNTER_DEFAULT_COLOR = '#434548';
const TEXT_COUNTER_INVALID_COLOR = '#FF3A4A';
const MAX_FILE_COUNT = 6;
const MAX_IMAGE_SIZE = 35 * 1024 * 1024; // 35MB
const MAX_VIDEO_SIZE = 35 * 1024 * 1024; // 35MB
const VIDEO_THUMBNAIL_TIMEOUT_MS = 3000;
const MAX_FAQ_REFERENCE_COUNT = 6;
const filePreviewUrlMap = new Map();
let cachedFaqMappings = [];
const FILE_ERROR_MESSAGES = {
  size: '파일 용량을 초과하였습니다.',
  count: '첨부 가능 수량을 초과하였습니다.',
  type: '지원하는 파일 형식이 아닙니다.'
};

document.addEventListener('DOMContentLoaded', async () => {
  await initStep2();
});

async function initStep2() {
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const textarea = document.querySelector('#as-form-2 .box-text textarea');
  const fileInput = document.querySelector('#as-form-2 #file-upload');
  cachedFaqMappings = getFaqMappings();
  const updateFaq = () => refreshStep2FaqLinks();

  // 부위/증상 공통코드(AA1/AA2) 동적 로드
  await initializeAsCodeMappings(partSelect, symptomSelect);

  // 부위별 설명 보기 버튼
  const partDescBtn = document.querySelector('#as-form-2 .as-symptom-desc');
  if (partDescBtn) {
    partDescBtn.addEventListener('click', openPartDescModal);
  }

  // 1. 부위/증상 선택 기능
  setupSymptomSelection(partSelect, symptomSelect, updateFaq);

  // 2. 상세 증상 입력 (800자 제한)
  setupTextareaLimit(textarea);

  // 3. 파일 첨부 기능
  setupFileUpload(fileInput);

  // 4. 첨부 예시 영상 재생
  setupExampleVideo();

  updateFaq();
}

async function initializeAsCodeMappings(partSelect, symptomSelect) {
  if (!partSelect || !symptomSelect) return;

  const [parentResult, childResult] = await Promise.allSettled([
    fetchAsCodeInfo(AS_CODE_PARENT),
    fetchAsCodeInfo(AS_CODE_CHILD)
  ]);

  const parentRows = parentResult.status === 'fulfilled' ? parentResult.value : [];
  const childRows = childResult.status === 'fulfilled' ? childResult.value : [];

  const normalizedParents = parentRows
    .map(normalizeCodeInfoRow)
    .filter((row) => row.ccdCd && row.ccdNm);

  const normalizedChildren = childRows
    .map(normalizeCodeInfoRow)
    .filter((row) => row.parentCd && row.ccdCd && row.ccdNm);

  const nextPartList = {};
  const nextPartOrder = [];
  normalizedParents.forEach((row) => {
    if (nextPartList[row.ccdCd]) return;
    nextPartList[row.ccdCd] = row.ccdNm;
    nextPartOrder.push(row.ccdCd);
  });

  isPartCodeLoadSucceeded = nextPartOrder.length > 0;
  if (isPartCodeLoadSucceeded) {
    dynamicPartList = nextPartList;
    dynamicPartOrder = nextPartOrder;
    renderPartOptions(partSelect);
    setAsCodeLoadWarning(partSelect, '');
  } else {
    dynamicPartList = {};
    dynamicPartOrder = [];
    disablePartSelect(partSelect);
    setAsCodeLoadWarning(partSelect, AS_PART_CODE_LOAD_ERROR_TEXT);
    if (parentResult.status === 'rejected') {
      console.error('AS 부위 코드(AA1) 로딩 실패:', parentResult.reason);
    } else {
      console.error('AS 부위 코드(AA1) 응답이 비어 있습니다.');
    }
  }

  const nextSymptomsByParent = {};
  normalizedChildren.forEach((row) => {
    // AA1.CCD_CD == AA2.PARENTS_CD 인 경우만 매핑
    if (!nextPartList[row.parentCd]) return;
    if (!nextSymptomsByParent[row.parentCd]) {
      nextSymptomsByParent[row.parentCd] = [];
    }
    nextSymptomsByParent[row.parentCd].push({
      code: row.ccdCd,
      name: row.ccdNm
    });
  });

  isSymptomCodeLoadSucceeded = Object.keys(nextSymptomsByParent).length > 0;
  if (isSymptomCodeLoadSucceeded) {
    dynamicSymptomsByParent = nextSymptomsByParent;
    setAsCodeLoadWarning(symptomSelect, '');
  } else {
    dynamicSymptomsByParent = {};
    resetSymptomSelect(symptomSelect);
    setAsCodeLoadWarning(symptomSelect, AS_SYMPTOM_CODE_LOAD_ERROR_TEXT);
    if (childResult.status === 'rejected') {
      console.error('AS 증상 코드(AA2) 로딩 실패:', childResult.reason);
    } else {
      console.error('AS 증상 코드(AA2) 응답이 비어 있거나 매핑 가능한 데이터가 없습니다.');
    }
  }

  const isAnyCodeLoadFailed = !isPartCodeLoadSucceeded || !isSymptomCodeLoadSucceeded;
  if (isAnyCodeLoadFailed) {
    disablePartSelect(partSelect);
    resetSymptomSelect(symptomSelect);
    setAsCodeLoadFailureState(partSelect, symptomSelect, true);
  } else {
    setAsCodeLoadFailureState(partSelect, symptomSelect, false);
  }

  updateFormData('part', '');
  updateFormData('part_name', '');
  updateFormData('symptom', '');
  updateFormData('symptom_name', '');
}

async function fetchAsCodeInfo(cdxCd) {
  const response = await fetch(AS_CODE_INFO_ENDPOINT, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ cdxCd })
  });

  if (!response.ok) {
    throw new Error(`asCodeInfo ${cdxCd} HTTP ${response.status}`);
  }

  const json = await response.json();
  return Array.isArray(json?.list) ? json.list : [];
}

function normalizeCodeInfoRow(row) {
  return {
    ccdCd: readCodeField(row, ['CCD_CD', 'ccdCd', 'ccd_cd']),
    ccdNm: readCodeField(row, ['CCD_NM', 'ccdNm', 'ccd_nm']),
    parentCd: readCodeField(row, ['PARENTS_CD', 'parentsCd', 'parentCd', 'PARENT_CD'])
  };
}

function readCodeField(source, candidates) {
  if (!source || typeof source !== 'object') return '';
  for (const key of candidates) {
    const value = source[key];
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      return String(value).trim();
    }
  }
  return '';
}

function renderPartOptions(partSelect) {
  if (!partSelect) return;

  // 기본 placeholder 유지
  partSelect.innerHTML = '<option value="" disabled selected hidden>옵션 선택</option>';
  dynamicPartOrder.forEach((partCode) => {
    const option = document.createElement('option');
    option.value = partCode;
    option.textContent = dynamicPartList[partCode];
    partSelect.appendChild(option);
  });
  partSelect.disabled = dynamicPartOrder.length === 0;
  partSelect.style.color = '#A4AAB0';
}

function resetSymptomSelect(symptomSelect) {
  if (!symptomSelect) return;
  symptomSelect.disabled = true;
  symptomSelect.innerHTML = '<option value="" disabled selected hidden>옵션 선택</option>';
  symptomSelect.style.color = '#A4AAB0';
  updateFormData('symptom', '');
  updateFormData('symptom_name', '');
}

function disablePartSelect(partSelect) {
  if (!partSelect) return;
  partSelect.disabled = true;
  partSelect.innerHTML = '<option value="" disabled selected hidden>옵션 선택</option>';
  partSelect.style.color = '#A4AAB0';
}

function getAsCodeLoadWarningElement(selectEl) {
  const container = selectEl?.closest('.as-symptom-select');
  if (!container) return null;

  let warningEl = container.querySelector('.as-code-load-warning');
  if (warningEl) return warningEl;

  warningEl = document.createElement('div');
  warningEl.className = 'as-code-load-warning hidden';
  container.appendChild(warningEl);
  return warningEl;
}

function setAsCodeLoadWarning(selectEl, message) {
  const warningEl = getAsCodeLoadWarningElement(selectEl);
  if (!warningEl) return;

  const text = String(message || '').trim();
  warningEl.textContent = text;
  warningEl.classList.toggle('hidden', text === '');
}

function setAsCodeLoadFailureState(partSelect, symptomSelect, failed) {
  const value = failed ? 'true' : 'false';
  if (partSelect) {
    partSelect.dataset.codeLoadFailed = value;
  }
  if (symptomSelect) {
    symptomSelect.dataset.codeLoadFailed = value;
  }
}

// ========================================
// 1. 부위/증상 선택 기능
// ========================================
function setupSymptomSelection(partSelect, symptomSelect, onSelectionChange) {
  if (!partSelect || !symptomSelect) return;
  const notify = typeof onSelectionChange === 'function' ? onSelectionChange : () => { };

  // 초기 색상 설정
  partSelect.style.color = '#A4AAB0';
  symptomSelect.style.color = '#A4AAB0';

  // 부위 선택 이벤트
  partSelect.addEventListener('change', (e) => {
    const selectedPart = e.target.value;
    partSelect.style.color = selectedPart ? '#000' : '#A4AAB0';

    // formData에 저장 (코드 + 한글명)
    updateFormData('part', selectedPart);
    updateFormData('part_name', dynamicPartList[selectedPart] || selectedPart);

    if (isSymptomCodeLoadSucceeded) {
      // 증상 옵션 업데이트
      updateSymptomOptions(symptomSelect, selectedPart);
    } else {
      resetSymptomSelect(symptomSelect);
    }

    // 에러 해제
    clearError(partSelect);

    // 다음 버튼 상태 체크
    checkNextButtonState(2);
    notify();
  });

  // 증상 선택 이벤트
  symptomSelect.addEventListener('change', (e) => {
    const selectedSymptom = e.target.value;
    symptomSelect.style.color = selectedSymptom ? '#000' : '#A4AAB0';
    const symptomOptionText = e.target.options[e.target.selectedIndex]?.text || '';

    // formData에 저장
    updateFormData('symptom', selectedSymptom);
    updateFormData('symptom_name', symptomOptionText);

    // 에러 해제
    clearError(symptomSelect);

    // 다음 버튼 상태 체크
    checkNextButtonState(2);
    notify();
  });

  notify();
}

// 증상 옵션 업데이트 (부위별 매핑 기반)
function updateSymptomOptions(symptomSelect, selectedPart) {
  if (!symptomSelect) return;

  if (!isSymptomCodeLoadSucceeded) {
    resetSymptomSelect(symptomSelect);
    return;
  }

  // 기존 옵션 제거 (placeholder 제외)
  symptomSelect.innerHTML = '<option value="" disabled selected hidden>옵션 선택</option>';
  symptomSelect.style.color = '#A4AAB0';

  // 선택된 부위에 해당하는 증상 목록 가져오기
  const symptoms = dynamicSymptomsByParent[selectedPart] || [];

  if (!selectedPart || symptoms.length === 0) {
    symptomSelect.disabled = true;
    updateFormData('symptom', '');
    updateFormData('symptom_name', '');
    setAsCodeLoadWarning(symptomSelect, selectedPart ? AS_SYMPTOM_EMPTY_MAPPING_TEXT : '');
    return;
  }

  symptomSelect.disabled = false;
  setAsCodeLoadWarning(symptomSelect, '');

  // 새 옵션 추가
  symptoms.forEach((symptom) => {
    const option = document.createElement('option');
    if (typeof symptom === 'string') {
      option.value = symptom;
      option.textContent = symptom;
    } else {
      option.value = symptom.code || symptom.name;
      option.textContent = symptom.name || symptom.code;
    }
    symptomSelect.appendChild(option);
  });

  // 선택 초기화
  symptomSelect.value = "";
  updateFormData('symptom', '');
  updateFormData('symptom_name', '');
}

function getFaqMappings() {
  const dataEl = document.querySelector('[id^="as-symptom-faq-data-"]');
  if (!dataEl) return [];

  try {
    const data = JSON.parse(dataEl.textContent || '[]');
    return Array.isArray(data) ? data : [];
  } catch (error) {
    console.error('FAQ mapping data parse failed:', error);
    return [];
  }
}

function normalizeValue(value) {
  return String(value || '').trim().toLowerCase();
}

function compactValue(value) {
  return normalizeValue(value).replace(/[\s/(),.\-_[\]{}]/g, '');
}

function getPartCandidates(selectedPart) {
  const candidates = new Set();
  const normalizedSelectedPart = normalizeValue(selectedPart);

  if (!normalizedSelectedPart) return candidates;
  candidates.add(normalizedSelectedPart);

  // 선택값이 코드(HR 등)인 경우 한글명도 후보에 포함
  if (dynamicPartList[selectedPart]) {
    candidates.add(normalizeValue(dynamicPartList[selectedPart]));
  }

  // 선택값이 한글명인 경우 대응 코드도 후보에 포함
  Object.entries(dynamicPartList).forEach(([code, label]) => {
    if (normalizeValue(label) === normalizedSelectedPart) {
      candidates.add(normalizeValue(code));
    }
  });

  return candidates;
}

function isOperationSymptom(compactSymptom) {
  if (!compactSymptom) return false;
  const operationKeywords = ['작동', '조절', '고정', '레버', '높낮이'];
  return operationKeywords.some((keyword) => compactSymptom.includes(keyword));
}

function isSymptomMatch(selectedSymptom, mappingSymptom) {
  const normalizedSelected = normalizeValue(selectedSymptom);
  const normalizedMapping = normalizeValue(mappingSymptom);

  if (!normalizedSelected || !normalizedMapping) return false;
  if (normalizedSelected === normalizedMapping) return true;

  const compactSelected = compactValue(selectedSymptom);
  const compactMapping = compactValue(mappingSymptom);

  // 공백/기호 제거 후 동일하면 매칭
  if (compactSelected === compactMapping) return true;

  // "소음" <-> "소음 발생" 같은 포함 관계를 허용
  if (compactSelected && compactMapping &&
      (compactSelected.includes(compactMapping) || compactMapping.includes(compactSelected))) {
    return true;
  }

  // "작동 불량" <-> "각도 조절 불가/높이 조절 불가" 등 동작 계열 표현 호환
  if (isOperationSymptom(compactSelected) && isOperationSymptom(compactMapping)) {
    return true;
  }

  return false;
}

function refreshStep2FaqLinks() {
  const partSelect = document.querySelector('#as-form-2 .as-symptom .select-part');
  const symptomSelect = document.querySelector('#as-form-2 .as-symptom .select-symptom');
  const faqBox = document.querySelector('#as-form-2 .as-form-box.box-faq');
  const faqContainer = document.querySelector('#as-form-2 .as-form-faq');

  if (!Array.isArray(cachedFaqMappings) || cachedFaqMappings.length === 0) {
    cachedFaqMappings = getFaqMappings();
  }

  renderFaqLinks(partSelect, symptomSelect, cachedFaqMappings, faqContainer, faqBox);
}

function renderFaqLinks(partSelect, symptomSelect, faqMappings, faqContainer, faqBox) {
  if (!faqContainer || !faqBox) return;

  const selectedPart = partSelect ? partSelect.value : '';
  const selectedSymptom = symptomSelect ? symptomSelect.value : '';
  const selectedSymptomLabel = symptomSelect?.selectedOptions?.[0]?.textContent || '';
  const partCandidates = getPartCandidates(selectedPart);
  const normalizedSymptom = normalizeValue(selectedSymptom);
  const normalizedSymptomLabel = normalizeValue(selectedSymptomLabel);

  if (partCandidates.size === 0 || (!normalizedSymptom && !normalizedSymptomLabel)) {
    faqContainer.replaceChildren();
    faqBox.classList.add('hidden');
    return;
  }

  const linkMap = new Map();
  faqMappings.forEach((item) => {
    if (!item) return;
    if (!partCandidates.has(normalizeValue(item.part))) return;
    const symptomMatched =
      isSymptomMatch(selectedSymptom, item.symptom) ||
      isSymptomMatch(selectedSymptomLabel, item.symptom);
    if (!symptomMatched) return;
    if (!Array.isArray(item.links)) return;

    item.links.forEach((link) => {
      if (!link || !link.url) return;
      if (!linkMap.has(link.url)) {
        linkMap.set(link.url, link.title || link.url);
      }
    });
  });

  faqContainer.replaceChildren();
  let renderedCount = 0;
  linkMap.forEach((title, url) => {
    if (renderedCount >= MAX_FAQ_REFERENCE_COUNT) return;
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noopener';
    anchor.textContent = title;
    faqContainer.appendChild(anchor);
    renderedCount += 1;
  });

  if (renderedCount > 0) {
    faqBox.classList.remove('hidden');
  } else {
    faqBox.classList.add('hidden');
  }
}

// ========================================
// 2. 상세 증상 입력 (800자 제한)
// ========================================

const TEXTAREA_TEMPLATE = '· 발생 시점: \n· 발생 상황: \n· 증상: \n· 지난 AS 여부: ';
const TEXTAREA_TEMPLATE_WITH_HINTS = '· 발생 시점: 언제부터\n· 발생 상황: 어떤 동작/조건에서\n· 증상: 소음/흔들림/작동불가 등 (최대한 구체적으로 작성해 주세요)\n· 지난 AS 여부: AS 진행이력 있음/없음';
const TEXTAREA_TEMPLATE_LINES = TEXTAREA_TEMPLATE.split('\n');
const TEXTAREA_TEMPLATE_TITLE = TEXTAREA_TEMPLATE_LINES[0] || '';
const TEXTAREA_TEMPLATE_PREFIXES = TEXTAREA_TEMPLATE_LINES.slice(1);
const TEXTAREA_TEMPLATE_HINT_LINES = TEXTAREA_TEMPLATE_WITH_HINTS.split('\n');

function isTemplateOnlyValue(value) {
  // 힌트 포함 전체 템플릿이거나, 힌트 없는 순수 템플릿인지 확인
  return value.trim() === TEXTAREA_TEMPLATE.trim() || value.trim() === TEXTAREA_TEMPLATE_WITH_HINTS.trim();
}

function normalizeTextareaValue(value) {
  return String(value || '').replace(/\r\n/g, '\n');
}

function findPrefixAtLineStart(value, prefix, fromIndex) {
  let searchIndex = Math.max(0, fromIndex);
  while (searchIndex <= value.length) {
    const index = value.indexOf(prefix, searchIndex);
    if (index === -1) return -1;
    if (index === 0 || value[index - 1] === '\n') return index;
    searchIndex = index + 1;
  }

  return -1;
}

function findTemplatePrefixSequence(value) {
  const normalizedValue = normalizeTextareaValue(value);
  let cursor = 0;
  const prefixIndexes = [];

  if (normalizedValue.startsWith(TEXTAREA_TEMPLATE_TITLE)) {
    cursor = TEXTAREA_TEMPLATE_TITLE.length;
  }

  for (const prefix of TEXTAREA_TEMPLATE_PREFIXES) {
    const index = normalizedValue.indexOf(prefix, cursor);
    if (index === -1) return null;
    prefixIndexes.push(index);
    cursor = index + prefix.length;
  }

  return prefixIndexes;
}

function escapeHtml(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function buildTemplateOverlayMarkup() {
  const lines = [];

  TEXTAREA_TEMPLATE_LINES.forEach((labelLine, index) => {
    const hintLine = TEXTAREA_TEMPLATE_HINT_LINES[index] || labelLine;
    let hintText = '';

    if (hintLine.startsWith(labelLine)) {
      hintText = hintLine.slice(labelLine.length);
    } else {
      const delimiterIndex = hintLine.indexOf(':');
      hintText = delimiterIndex >= 0 ? hintLine.slice(delimiterIndex + 1) : '';
    }

    lines.push(
      `<div class="template-line"><span class="template-label">${escapeHtml(labelLine)}</span><span class="template-hint">${escapeHtml(hintText)}</span></div>`
    );
  });

  return lines.join('');
}

function getAsSymptomUserInputText(value) {
  const normalizedValue = normalizeTextareaValue(value);
  if (!normalizedValue) return '';
  if (isTemplateOnlyValue(normalizedValue)) return '';

  const prefixIndexes = findTemplatePrefixSequence(normalizedValue);
  if (!prefixIndexes || prefixIndexes.length === 0) {
    return normalizedValue;
  }

  const sections = [];
  const titleEnd = normalizedValue.startsWith(TEXTAREA_TEMPLATE_TITLE)
    ? TEXTAREA_TEMPLATE_TITLE.length
    : 0;
  const firstPrefixStart = prefixIndexes[0];
  let firstSectionValue = normalizedValue.slice(titleEnd, firstPrefixStart);

  // 1번째 항목 구분용 줄바꿈 1개는 글자 수 계산에서 제외한다.
  if (firstSectionValue.endsWith('\n')) {
    firstSectionValue = firstSectionValue.slice(0, -1);
  }
  sections.push(firstSectionValue);

  for (let i = 0; i < prefixIndexes.length; i++) {
    const start = prefixIndexes[i] + TEXTAREA_TEMPLATE_PREFIXES[i].length;
    const end = i < prefixIndexes.length - 1 ? prefixIndexes[i + 1] : normalizedValue.length;
    let sectionValue = normalizedValue.slice(start, end);

    // 기본 템플릿 구분용 줄바꿈 1개는 글자 수 계산에서 제외한다.
    if (i < prefixIndexes.length - 1 && sectionValue.endsWith('\n')) {
      sectionValue = sectionValue.slice(0, -1);
    }

    sections.push(sectionValue);
  }

  return sections.join('');
}

function getAsSymptomUserInputLength(value) {
  const userInput = getAsSymptomUserInputText(value);
  return userInput.length;
}

if (typeof window !== 'undefined') {
  window.getAsSymptomUserInputText = getAsSymptomUserInputText;
  window.getAsSymptomUserInputLength = getAsSymptomUserInputLength;
  // 하위 호환: 기존 참조가 남아있어도 동일 기준(글자 수)으로 동작하도록 유지
  window.getAsSymptomUserInputBytes = getAsSymptomUserInputLength;
  window.AS_MIN_SYMPTOM_LENGTH = MIN_CHAR_LIMIT;
}

function getTemplateProtectedRanges(value) {
  const normalizedValue = normalizeTextareaValue(value);
  const ranges = [];
  let cursor = 0;

  if (normalizedValue.startsWith(TEXTAREA_TEMPLATE_TITLE)) {
    ranges.push({
      start: 0,
      end: TEXTAREA_TEMPLATE_TITLE.length,
      type: 'label'
    });
    cursor = TEXTAREA_TEMPLATE_TITLE.length;
  }

  TEXTAREA_TEMPLATE_PREFIXES.forEach((prefix) => {
    const index = findPrefixAtLineStart(normalizedValue, prefix, cursor);
    if (index === -1) return;
    ranges.push({
      start: index,
      end: index + prefix.length,
      type: 'label'
    });
    cursor = index + prefix.length;
  });

  return ranges;
}

function hasIntactTemplateStructure(value) {
  const normalizedValue = normalizeTextareaValue(value);
  if (!normalizedValue.startsWith(TEXTAREA_TEMPLATE_TITLE)) return false;

  return getTemplateProtectedRanges(normalizedValue).length === TEXTAREA_TEMPLATE_LINES.length;
}

function getTemplateEditablePositions() {
  return getTemplateProtectedRanges(TEXTAREA_TEMPLATE).map((range) => range.end);
}

function getClientPointFromEvent(event) {
  if (!event) return null;

  if (event.touches && event.touches[0]) {
    return {
      clientX: Number(event.touches[0].clientX),
      clientY: Number(event.touches[0].clientY),
    };
  }

  if (event.changedTouches && event.changedTouches[0]) {
    return {
      clientX: Number(event.changedTouches[0].clientX),
      clientY: Number(event.changedTouches[0].clientY),
    };
  }

  if (Number.isFinite(Number(event.clientX)) && Number.isFinite(Number(event.clientY))) {
    return {
      clientX: Number(event.clientX),
      clientY: Number(event.clientY),
    };
  }

  return null;
}

function resolveTemplateLineIndexFromPoint(templateOverlay, clientY) {
  const lines = Array.from(templateOverlay?.querySelectorAll('.template-line') || []);
  const pointY = Number(clientY);
  if (!lines.length || !Number.isFinite(pointY)) return -1;

  for (let i = 0; i < lines.length; i++) {
    const rect = lines[i].getBoundingClientRect();
    if (pointY >= rect.top && pointY <= rect.bottom) {
      return i;
    }
  }

  let nearestIndex = -1;
  let nearestDistance = Infinity;

  lines.forEach((line, index) => {
    const rect = line.getBoundingClientRect();
    const centerY = (rect.top + rect.bottom) / 2;
    const distance = Math.abs(centerY - pointY);
    if (distance < nearestDistance) {
      nearestDistance = distance;
      nearestIndex = index;
    }
  });

  return nearestIndex;
}

function intersectsProtectedRange(start, end, ranges) {
  return ranges.some((range) => start < range.end && end > range.start);
}

function isWithinProtectedRange(index, ranges) {
  return ranges.some((range) => index >= range.start && index < range.end);
}

function findNextEditablePosition(index, ranges, maxLength) {
  for (const range of ranges) {
    if (index >= range.start && index < range.end) {
      return Math.min(range.end, maxLength);
    }
  }

  return Math.min(index, maxLength);
}


function setupTextareaLimit(textarea) {
  if (!textarea) return;

  const pcCounter = document.querySelector('#as-form-2 .box-text .text-limit.pc');
  const mobileCounter = document.querySelector('#as-form-2 .box-text .text-limit.mobile');
  const templateOverlay = textarea.parentElement?.querySelector('.as-textarea-template-overlay') || null;
  let pendingTemplateCaretPosition = null;

  // 초기 템플릿 설정 (힌트 포함)
  textarea.value = TEXTAREA_TEMPLATE_WITH_HINTS;
  if (templateOverlay) {
    templateOverlay.innerHTML = buildTemplateOverlayMarkup();
  }

  function updateCounter(value) {
    const totalLength = getAsSymptomUserInputLength(value);
    const counterColor = totalLength >= MIN_CHAR_LIMIT ? TEXT_COUNTER_DEFAULT_COLOR : TEXT_COUNTER_INVALID_COLOR;
    const counterHtml = `<span style="color:${counterColor};">${totalLength}</span>/${MAX_CHAR_LIMIT}`;

    if (pcCounter) {
      pcCounter.style.color = TEXT_COUNTER_DEFAULT_COLOR;
      pcCounter.innerHTML = counterHtml;
    }

    if (mobileCounter) {
      mobileCounter.style.color = TEXT_COUNTER_DEFAULT_COLOR;
      mobileCounter.innerHTML = counterHtml;
    }
  }

  function syncTemplateHintState() {
    const isTemplateValue = isTemplateOnlyValue(textarea.value);
    textarea.classList.toggle('textarea-template-hint', isTemplateValue);
    textarea.classList.toggle('textarea-template-hint-overlay-active', isTemplateValue);
    if (templateOverlay) {
      templateOverlay.classList.toggle('active', isTemplateValue);
    }
  }

  function moveCaretToEditablePosition() {
    const start = textarea.selectionStart ?? 0;
    const end = textarea.selectionEnd ?? start;
    if (start !== end) return;

    const ranges = getTemplateProtectedRanges(textarea.value);
    if (!isWithinProtectedRange(start, ranges)) return;

    const nextPos = findNextEditablePosition(start, ranges, textarea.value.length);
    textarea.setSelectionRange(nextPos, nextPos);
  }

  function scheduleCaretNormalization() {
    requestAnimationFrame(() => {
      if (document.activeElement !== textarea) return;
      moveCaretToEditablePosition();
    });
  }

  function rememberTemplateCaretPosition(event) {
    if (!templateOverlay || !isTemplateOnlyValue(textarea.value)) return;

    const point = getClientPointFromEvent(event);
    if (!point) return;

    const lineIndex = resolveTemplateLineIndexFromPoint(templateOverlay, point.clientY);
    if (lineIndex < 0) return;

    const editablePositions = getTemplateEditablePositions();
    const nextPosition = editablePositions[lineIndex];
    if (!Number.isFinite(nextPosition)) return;

    pendingTemplateCaretPosition = nextPosition;
  }

  function applyPendingTemplateCaretPosition() {
    const nextPosition = Number.isFinite(pendingTemplateCaretPosition)
      ? pendingTemplateCaretPosition
      : null;
    pendingTemplateCaretPosition = null;

    if (nextPosition === null) {
      scheduleCaretNormalization();
      return;
    }

    setTimeout(() => {
      if (document.activeElement !== textarea) return;
      const clampedPosition = Math.min(nextPosition, textarea.value.length);
      textarea.setSelectionRange(clampedPosition, clampedPosition);
    }, 0);
  }

  let isComposing = false;
  let lastSyncedValue = normalizeTextareaValue(textarea.value);

  function syncTextareaState(force = false) {
    let value = normalizeTextareaValue(textarea.value);
    if (value !== textarea.value) {
      textarea.value = value;
    }

    const lastValueHasTemplate = hasIntactTemplateStructure(lastSyncedValue);
    const currentValueStartsWithTemplate = value.startsWith(TEXTAREA_TEMPLATE_TITLE);
    if (lastValueHasTemplate && currentValueStartsWithTemplate && !hasIntactTemplateStructure(value)) {
      value = lastSyncedValue;
      textarea.value = value;
      scheduleCaretNormalization();
    }

    // 800자 초과 방지
    if (value.length > MAX_CHAR_LIMIT) {
      value = value.substring(0, MAX_CHAR_LIMIT);
      textarea.value = value;
    }

    if (!force && value === lastSyncedValue) return;
    lastSyncedValue = value;

    // 글자 수 업데이트
    updateCounter(value);

    // 실제 사용자 입력값을 formData에 저장 (템플릿 포함 전체 텍스트)
    const savedValue = isTemplateOnlyValue(value) ? '' : value;
    updateFormData('symptom_desc', savedValue);
    syncTemplateHintState();

    // 다음 버튼 상태 체크
    checkNextButtonState(2);
  }

  // 포커스 시: 힌트 제거 (순수 템플릿만 남김)
  textarea.addEventListener('focus', () => {
    if (isTemplateOnlyValue(textarea.value)) {
      textarea.value = TEXTAREA_TEMPLATE;
    }
    syncTextareaState(true);
    applyPendingTemplateCaretPosition();
  });

  // 블러 시: 입력 없으면 힌트 복원
  textarea.addEventListener('blur', () => {
    pendingTemplateCaretPosition = null;
    if (isTemplateOnlyValue(textarea.value)) {
      textarea.value = TEXTAREA_TEMPLATE_WITH_HINTS;
    }
    syncTextareaState(true);
  });

  // 자동 템플릿 라벨 영역 수정 차단
  textarea.addEventListener('beforeinput', (e) => {
    const inputType = e.inputType || '';
    if (!inputType) return;

    const ranges = getTemplateProtectedRanges(textarea.value);
    if (ranges.length === 0) return;

    const start = textarea.selectionStart ?? 0;
    const end = textarea.selectionEnd ?? start;
    const isCollapsed = start === end;

    if (inputType.startsWith('delete')) {
      let deleteStart = start;
      let deleteEnd = end;

      if (isCollapsed) {
        if (inputType === 'deleteContentBackward') {
          deleteStart = Math.max(0, start - 1);
        } else {
          deleteEnd = Math.min(textarea.value.length, end + 1);
        }
      }

      if (intersectsProtectedRange(deleteStart, deleteEnd, ranges)) {
        e.preventDefault();
      }
      return;
    }

    if (!isCollapsed) {
      if (intersectsProtectedRange(start, end, ranges)) {
        e.preventDefault();
      }
      return;
    }

    if (isWithinProtectedRange(start, ranges)) {
      e.preventDefault();
      const nextPos = findNextEditablePosition(start, ranges, textarea.value.length);
      textarea.setSelectionRange(nextPos, nextPos);
    }
  });

  textarea.addEventListener('mousedown', rememberTemplateCaretPosition);
  textarea.addEventListener('touchstart', rememberTemplateCaretPosition, { passive: true });
  textarea.addEventListener('click', moveCaretToEditablePosition);
  textarea.addEventListener('mouseup', scheduleCaretNormalization);
  textarea.addEventListener('touchend', scheduleCaretNormalization, { passive: true });
  textarea.addEventListener('select', scheduleCaretNormalization);

  textarea.addEventListener('compositionstart', () => {
    moveCaretToEditablePosition();
    isComposing = true;
  });

  textarea.addEventListener('compositionend', () => {
    isComposing = false;
    syncTextareaState(true);
  });

  textarea.addEventListener('keyup', () => {
    if (isComposing) return;
    syncTextareaState();
  });

  textarea.addEventListener('input', () => {
    syncTextareaState(true);
  });

  document.addEventListener('selectionchange', () => {
    if (document.activeElement !== textarea) return;
    scheduleCaretNormalization();
  });

  syncTextareaState(true);
}

// ========================================
// 3. 파일 첨부 기능
// ========================================
function setupFileUpload(fileInput) {
  if (!fileInput) return;

  fileInput.addEventListener('change', (e) => {
    const files = Array.from(e.target.files);

    if (files.length === 0) return;

    // 현재 첨부된 파일 개수 확인
    const currentFiles = formData.attach_file || [];
    const remainingSlots = MAX_FILE_COUNT - currentFiles.length;

    if (remainingSlots <= 0) {
      showFileError('count');
      e.target.value = ''; // input 초기화
      return;
    }

    // 파일 검증 및 추가
    const validFiles = [];
    const hasCountOverflow = files.length > remainingSlots;

    if (hasCountOverflow) {
      showFileError('count');
    }

    for (let i = 0; i < files.length && validFiles.length < remainingSlots; i++) {
      const file = files[i];
      const validation = validateFile(file);

      if (validation.isValid) {
        validFiles.push(file);
      } else {
        showFileError(validation.errorType);
      }
    }

    // 유효한 파일만 추가
    if (validFiles.length > 0) {
      addFilesToFormData(validFiles);
      renderFilePreview();
      if (!hasCountOverflow) {
        hideFileError();
      }
    }

    // input 초기화
    e.target.value = '';

    // 다음 버튼 상태 체크
    checkNextButtonState(2);
  });
}

// 파일 검증
function validateFile(file) {
  const isImage = file.type.startsWith('image/');
  const isVideo = file.type.startsWith('video/');

  // 이미지/동영상이 아닌 경우
  if (!isImage && !isVideo) {
    return { isValid: false, errorType: 'type' };
  }

  // 용량 검증
  if (isImage && file.size > MAX_IMAGE_SIZE) {
    return { isValid: false, errorType: 'size' };
  }

  if (isVideo && file.size > MAX_VIDEO_SIZE) {
    return { isValid: false, errorType: 'size' };
  }

  return { isValid: true };
}

// formData에 파일 추가
function addFilesToFormData(files) {
  if (!formData.attach_file) {
    formData.attach_file = [];
  }

  files.forEach(file => {
    formData.attach_file.push(file);
  });
}

function getFilePreviewUrl(file) {
  if (!(file instanceof File)) return '';

  if (!filePreviewUrlMap.has(file)) {
    filePreviewUrlMap.set(file, URL.createObjectURL(file));
  }

  return filePreviewUrlMap.get(file) || '';
}

function revokeFilePreviewUrl(file) {
  if (!filePreviewUrlMap.has(file)) return;

  const targetUrl = filePreviewUrlMap.get(file);
  if (targetUrl) {
    URL.revokeObjectURL(targetUrl);
  }
  filePreviewUrlMap.delete(file);
}

function syncFilePreviewUrls(files) {
  const currentFiles = new Set((files || []).filter((file) => file instanceof File));
  filePreviewUrlMap.forEach((url, file) => {
    if (!currentFiles.has(file)) {
      URL.revokeObjectURL(url);
      filePreviewUrlMap.delete(file);
    }
  });
}

// 파일 미리보기 렌더링
function renderFilePreview() {
  const container = document.querySelector('#as-form-2 .as-attach-file');
  if (!container) return;

  const rawFiles = Array.isArray(formData.attach_file) ? formData.attach_file : [];
  const files = rawFiles.filter((file) => file instanceof File);
  if (files.length !== rawFiles.length) {
    formData.attach_file = files;
  }

  syncFilePreviewUrls(files);

  // 기존 미리보기 제거 (input 제외)
  const existingPreviews = container.querySelectorAll('.attach-box-image');
  existingPreviews.forEach(preview => preview.remove());

  // 새 미리보기 생성
  files.forEach((file, index) => {
    const fileURL = getFilePreviewUrl(file);
    const previewBox = createFilePreviewBox(file, index, fileURL);
    container.appendChild(previewBox);
  });
}

// 파일 미리보기 박스 생성
function createFilePreviewBox(file, index, fileURL) {
  const box = document.createElement('div');
  box.className = 'attach-box attach-box-image';
  box.dataset.fileIndex = index;

  // 이미지인 경우 썸네일 표시
  if (file.type.startsWith('image/')) {
    box.style.backgroundImage = `url('${fileURL}')`;

    // 클릭 시 새 창에서 이미지 열기
    box.style.cursor = 'pointer';
    box.addEventListener('click', (e) => {
      if (!e.target.closest('button')) {
        window.open(fileURL, '_blank');
      }
    });
  } else if (file.type.startsWith('video/')) {
    // 동영상 썸네일 생성
    createVideoThumbnail(file, fileURL, box);

    // 클릭 시 동영상 재생
    box.style.cursor = 'pointer';
    box.addEventListener('click', (e) => {
      if (!e.target.closest('button')) {
        window.open(fileURL, '_blank');
      }
    });
  }

  // 삭제 버튼
  const deleteBtn = document.createElement('button');
  deleteBtn.type = 'button';
  deleteBtn.innerHTML = `<img src="${icon_close}" class="delete" alt="파일 삭제" width="auto" height="auto">`;

  deleteBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    removeFile(index);
  });

  box.appendChild(deleteBtn);

  return box;
}

function appendVideoPlayIcon(box) {
  if (!box || box.querySelector('.video-play-icon')) return;

  const playIcon = document.createElement('img');
  playIcon.src = icon_play_button;
  playIcon.className = 'video-play-icon';
  playIcon.style.cssText = `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 24px;
    height: 24px;
    pointer-events: none;
  `;
  box.appendChild(playIcon);
}

function applyVideoPreviewFallback(box) {
  if (!box) return;
  box.style.backgroundImage = 'none';
  box.style.backgroundColor = '#eaeaea';
  appendVideoPlayIcon(box);
}

// 동영상 썸네일 생성
function createVideoThumbnail(file, fileURL, box) {
  const video = document.createElement('video');
  video.src = fileURL;
  video.muted = true;
  video.playsInline = true;
  video.preload = 'metadata';

  const fallbackTimer = setTimeout(() => {
    applyVideoPreviewFallback(box);
  }, VIDEO_THUMBNAIL_TIMEOUT_MS);

  const clearFallbackTimer = () => {
    clearTimeout(fallbackTimer);
  };

  // 첫 프레임 로드 후 캡처
  video.addEventListener('loadeddata', () => {
    try {
      if (!Number.isFinite(video.duration) || video.duration <= 0) {
        video.currentTime = 0;
        return;
      }
      video.currentTime = Math.min(0.1, Math.max(video.duration - 0.01, 0));
    } catch (error) {
      clearFallbackTimer();
      applyVideoPreviewFallback(box);
    }
  }, { once: true });

  video.addEventListener('seeked', () => {
    try {
      // 캔버스로 썸네일 생성
      const canvas = document.createElement('canvas');
      canvas.width = 60;
      canvas.height = 60;
      const ctx = canvas.getContext('2d');
      if (!ctx || !video.videoWidth || !video.videoHeight) {
        throw new Error('invalid-video-frame');
      }

      // 비디오 비율 유지하며 그리기
      const aspectRatio = video.videoWidth / video.videoHeight;
      let drawWidth = canvas.width;
      let drawHeight = canvas.height;
      let offsetX = 0;
      let offsetY = 0;

      if (aspectRatio > 1) {
        drawHeight = canvas.width / aspectRatio;
        offsetY = (canvas.height - drawHeight) / 2;
      } else {
        drawWidth = canvas.height * aspectRatio;
        offsetX = (canvas.width - drawWidth) / 2;
      }

      ctx.drawImage(video, offsetX, offsetY, drawWidth, drawHeight);

      // 썸네일 설정
      box.style.backgroundImage = `url('${canvas.toDataURL()}')`;
      box.style.backgroundColor = '#eaeaea';
      appendVideoPlayIcon(box);
    } catch (error) {
      applyVideoPreviewFallback(box);
    } finally {
      clearFallbackTimer();
    }
  }, { once: true });

  video.addEventListener('error', () => {
    clearFallbackTimer();
    applyVideoPreviewFallback(box);
  }, { once: true });

  video.load();
}

// 파일 삭제
function removeFile(index) {
  if (!formData.attach_file) return;

  // URL 해제
  const file = formData.attach_file[index];
  if (file instanceof File) {
    revokeFilePreviewUrl(file);
  }

  // formData에서 제거
  formData.attach_file.splice(index, 1);

  // UI 업데이트
  renderFilePreview();
  hideFileError();

  // 다음 버튼 상태 체크
  checkNextButtonState(2);
}

// 파일 에러 표시
function showFileError(errorType) {
  const sizeError = document.querySelector('#as-form-2 .as-form-box .text-error.file-size');
  const countError = document.querySelector('#as-form-2 .as-form-box .text-error.file-count');
  const typeError = document.querySelector('#as-form-2 .as-form-box .text-error.file-type');

  hideFileError();

  if (errorType === 'size' && sizeError) {
    sizeError.textContent = FILE_ERROR_MESSAGES.size;
    sizeError.classList.remove('hidden');
  }
  if (errorType === 'count' && countError) {
    countError.textContent = FILE_ERROR_MESSAGES.count;
    countError.classList.remove('hidden');
  }
  if (errorType === 'type' && typeError) {
    typeError.textContent = FILE_ERROR_MESSAGES.type;
    typeError.classList.remove('hidden');
  }
}

// 파일 에러 숨김
function hideFileError() {
  const errors = document.querySelectorAll('#as-form-2 .as-form-box .text-error.file-size, #as-form-2 .as-form-box .text-error.file-count, #as-form-2 .as-form-box .text-error.file-type, #as-form-2 .as-form-box .text-error.file-no');

  errors.forEach(error => error.classList.add('hidden'));
}

// ========================================
// 유틸리티 함수
// ========================================

// 에러 클래스 제거
function clearError(element) {
  if (!element) return;

  const container = element.closest('.as-symptom-select');

  // 에러 메시지 숨김
  if (container) {
    const errorMsg = container.querySelector('.text-error');
    if (errorMsg) {
      errorMsg.classList.add('hidden');
    }
  }
}

// ========================================
// 4. 첨부 예시 영상 재생
// ========================================
function setupExampleVideo() {
  const videoItems = document.querySelectorAll('#as-form-2 .image-item-video');

  videoItems.forEach((videoItem) => {
    const video = videoItem.querySelector('video');
    const playBtn = videoItem.querySelector('.video-play-btn');
    if (!video || !playBtn) return;

    playBtn.addEventListener('click', () => {
      videoItem.classList.add('playing');
      video.play();
    });

    video.addEventListener('ended', () => {
      videoItem.classList.remove('playing');
      video.currentTime = 0;
    });

    video.addEventListener('click', () => {
      if (!video.paused) {
        video.pause();
        videoItem.classList.remove('playing');
      }
    });
  });
}

// 부위별 설명 보기 모달
function openPartDescModal() {
  let modalContent = `
		<div class="mypage-register-modal">
      <div class="mypage-register-modal-wrapper">
        <div class="body-1">
          <img src="${img_as_part}" alt="부위별 설명" width="100%" height="100%" />
        </div>
      </div>
    </div>
  `;

  openModalWithContent("부위별 설명 보기", modalContent, function () {
    document.getElementById("site-alert-modal").classList.add("height-auto--modal");
    let modalContents = document.querySelector('.modal--contents');
    if(modalContents) {
      modalContents.removeAttribute('style'); // 인라인 스타일 제거
    }
  });
}
